/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

import '../public/css/style.css';

/*import VueHtmlToPaper from 'vue-html-to-paper';
 
const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles:[process.env.BASE_URL + 'css/style.css'] 
}
// import acl from './acl/acl'
Vue.use(VueHtmlToPaper, options);*/
//vee-validate
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  events: 'change'
});
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

Vue.use(Vuesax)
// axios
import axios from 'axios'
Vue.prototype.$http = axios
let axiosDefaults = require('axios/lib/defaults');
//axiosDefaults.baseURL = 'http://localhost:6060/SmartReceiver/services/';
axiosDefaults.baseURL ='https://smartlabs.co.in/smartclinicapi/';
//axiosDefaults.baseURL ='http://103.161.54.139:6060/SmartReceiver/services/';
axios.interceptors.request.use((config) => {
  // get values from session
  const userToken = Vue.prototype.$session.get("userToken");
  const userId = Vue.prototype.$session.get("userId");
  const companyId = Vue.prototype.$session.get("companyId");

  // if values exist, attach them to headers
  if (userToken && userId && companyId) {
    config.headers["AUTH_KEY"] = userToken;
    config.headers["USER_ID"] = userId;
    config.headers["COMPANY_ID"] = companyId;
  }
  
  return config;
}, (error) => {
  return Promise.reject(error);
});
/*axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.statusCode === 401) {
      alert('Your session expired. Please login again.');
      Vue.prototype.$session.destroy();
      window.location.href = '/login';
      return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      alert('Session expired. Please login again.');
      Vue.prototype.$session.destroy();
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);*/
axios.interceptors.response.use(
  (response) => {
    if (response.data && response.data.statusCode === 401) {
      Vue.prototype.$vs.notify({
        title: 'Session Expired',
        text: 'Your session has expired or another login was detected. Please log in again.',
        color: 'danger',
        position: 'top-right'
      });

      Vue.prototype.$session.destroy();

      // ⏳ Wait 2 seconds before redirecting
      setTimeout(() => {
        window.location.href = '/login';
      }, 5000);

     return Promise.reject(response);
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      Vue.prototype.$vs.notify({
        title: 'Session Expired',
        text: 'Please log in again to continue.',
        color: 'warning',
        position: 'top-right'
      });

      Vue.prototype.$session.destroy();

      // ⏳ Wait 2 seconds before redirecting
      setTimeout(() => {
        window.location.href = '/login';
      }, 5000);

      return Promise.reject(error);
    }
    return Promise.reject(error);
  }
);


//session
import VueSession from 'vue-session'
Vue.use(VueSession)
// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'


import 'vue-select/dist/vue-select.css';
// Styles: SCSS
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuesax Admin Filters
import './filters/filters'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')
import 'ag-grid-community/dist/styles/ag-grid.css'
import 'ag-grid-community/dist/styles/ag-theme-material.css'


import VueGoodTablePlugin from 'vue-good-table';

// import the styles
import 'vue-good-table/dist/vue-good-table.css'

Vue.use(VueGoodTablePlugin);
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
